import React from 'react'
import { StyledSectionTitle } from './styles'

const DrawerSectionTitle = ({ title }) => {
  return <StyledSectionTitle>{title}</StyledSectionTitle>
}

export { DrawerSectionTitle }
